/*
 *
 * Copyright 2019-2024, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

/**
 * React component wrapper around datatables.net
 * https://datatables.net
 * https://www.npmjs.com/package/datatables.net
 *
 * based on:
 * https://www.npmjs.com/package/react-datatables
 * https://github.com/luqin/react-DataTables
 */

import React from 'react';
import $ from 'jquery'; // eslint-disable-line

import 'datatables.net';
import 'datatables.net-buttons/js/buttons.html5.js';
import './WrcDataTables.css';
import PropTypes from "prop-types";

$.fn.dataTable.ext.errMode = function handleError(e, settings, techNote, message) { // eslint-disable-line
    console.error(arguments);
};

export class WrcDataTable extends React.Component {
    searchTable(e) {
        $(this.node).DataTable().search(
            e.target.value,
            false,  //$('#global_regex').prop('checked'),
            false   //$('#global_smart').prop('checked')
        ).draw();
    }

    configure() {
        // if scrollX, then wrap table in a <div class="horiz-scroll">
        const tableDom = this.props.scrollX ? 'r<"horiz-scroll"t>ip' : 'rtip';
        let toolbarDom = '';
        let buttonArray = [];
        if (this.props.exportButton) {
            toolbarDom = '<"toolbar"B>';
            buttonArray = [
                {
                    extend: 'csvHtml5',
                    text: this.props.exportButton,
                    title: this.props.exportFilename,
                },
            ];
        } else if (!this.props.disableToolbar) {
            toolbarDom = '<"toolbar">';
        }

        let options = Object.assign({
            retrieve: true, // if DataTable already initialized, just retrieve
            scrollCollapse: true,
            pageLength: this.props.page_length,
            dom: toolbarDom + tableDom,
            buttons: buttonArray,
            // stateSave: true,
            columnDefs: [{
                targets: 'nosort',
                orderable: false
            }],
            drawCallback: function(settings) {
                var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
                pagination.toggle(this.api().page.info().pages > 1);
            }
        }, this.props.options);

        if (!(this.props.disableScrollY)) {
            options.scrollY = (this.props.height ? `${Math.floor(this.props.height * 0.54)}px` : '50vh')
        }

        this.table = $(this.node).DataTable(options); // eslint-disable-line new-cap
        this.props.hidden_columns.forEach(function(hidden_column) {
            this.table.column(hidden_column).visible(false, false);
        }.bind(this));
        this.table.columns.adjust().draw(false);
    }

    componentDidMount() {
        this.configure();
    }

    componentDidUpdate() {
        this.configure();
    }

    componentWillUnmount() {
        const curpage = this.table.page();

        this.setState({
            curpage: curpage
        });

        this.table.destroy();
    }

    render() {
        // when we trigger re-renders in any parent component, this destroys and rebuilds the table
        // if (this.table) {
        //     this.table.destroy();
        // }
        //const {children} = this.props;

        let tableClass = 'bp3-html-table bp3-html-table-bordered bp3-html-table-striped ';
        if (this.props.className) {
            tableClass += this.props.className;
        }

        if (this.props.noWrapHeader === true) {
            tableClass += ' nowrap-headers'
        }

        let entity = this.props.entity.toLowerCase()
        let search_bar = null;
        if (this.props.show_search) {
            search_bar = (
                <div className="bp3-input-group">
                    <span className="bp3-icon bp3-icon-search"/>
                    <input className="bp3-input bp3-round" type="search" placeholder={"Search for " + entity} onChange={(e) => this.searchTable(e)}/>
                </div>
            );
        }
        return (
            <div>
                {search_bar}
                <table ref={node => this.node = node} className={tableClass} style={this.props.style}>
                    {this.props.children}
                </table>
            </div>
        );
    }
}

WrcDataTable.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dataSource: PropTypes.func,
    exportButton: PropTypes.string,
    exportFilename: PropTypes.string,
    index: PropTypes.number,
    options: PropTypes.object,
    order: PropTypes.array,
    page_length: PropTypes.number,
    scrollX: PropTypes.bool,
    show_search: PropTypes.bool,
    style: PropTypes.object,
    hidden_columns: PropTypes.array
};

WrcDataTable.defaultProps = {
    disableToolbar: false,
    exportButton: '',
    exportFilename: 'export',
    page_length: 5,
    scrollX: false,
    show_search: false,
    style: {width: '100%'},
    hidden_columns: []
};
